// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
:root {
  --primary-bg: #ffffff;
  --secondary-bg: #f7f7f7; /* Un gris muy claro para sutil contraste */
  --brand-color: #23223F;
  --accent-color: #FD5F56;
  --text-color: #333333;
  --text-secondary: #555555;
  --border-color: #eaeaea;
  --shadow-color: rgba(0, 0, 0, 0.05);
}

body {
  background-color: var(--secondary-bg);
  color: var(--text-color);
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.data-viewer {
  max-width: 1400px;
  margin: 2rem auto;
  padding: 1rem;
}

.app-header {
  text-align: center;
  margin-bottom: 2rem;
}

.app-header h1 {
  font-family: 'Montserrat', sans-serif;
  color: var(--brand-color);
  font-size: 2.8rem;
  font-weight: 700;
}

.controls-container {
  background-color: var(--primary-bg);
  padding: 1.5rem;
  border-radius: 12px;
  border: 1px solid var(--border-color);
  margin-bottom: 2rem;
}

.controls {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-end;
}

.controls input, .controls select {
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background-color: var(--secondary-bg);
  transition: all 0.2s ease-in-out;
}

.controls input:focus, .controls select:focus {
  border-color: var(--accent-color);
  box-shadow: 0 0 0 3px rgba(253, 95, 86, 0.2);
  outline: none;
}

.reset-btn {
    background-color: transparent;
    color: var(--accent-color);
    border: 1px solid var(--accent-color);
    padding: 0.75rem 1rem;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    transition: all 0.2s ease-in-out;
}

.reset-btn:hover {
    background-color: var(--accent-color);
    color: white;
}

.table-container {
  background-color: var(--primary-bg);
  border-radius: 12px;
  border: 1px solid var(--border-color);
  overflow: hidden;
}

table {
  width: 100%;
  border-collapse: collapse;
}

thead {
  background-color: var(--secondary-bg);
}

th {
  padding: 1.25rem 1.5rem;
  text-align: left;
  font-weight: 600;
  color: var(--brand-color);
  border-bottom: 2px solid var(--accent-color);
}

tbody tr {
  transition: background-color 0.15s ease-in-out;
}

tbody tr:not(:last-child) {
  border-bottom: 1px solid var(--border-color);
}

tbody tr:hover {
  background-color: var(--secondary-bg);
}

td {
  padding: 1rem 1.5rem;
  color: var(--text-secondary);
  vertical-align: middle;
}

td:first-child {
    color: var(--text-color);
    font-weight: 500;
}

.status, .type {
  padding: 0.3rem 0.75rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 500;
  display: inline-block;
}

.status.open {
  background-color: #e6f7ff;
  color: #1890ff;
}

.status.closed {
  background-color: #fff1f0;
  color: #f5222d;
}

.type.farmacia {
  background-color: #e6fffb;
  color: #13c2c2;
}

.type.establecimiento {
  background-color: #fffbe6;
  color: #faad14;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2rem;
  gap: 1rem;
}

.pagination button {
  background-color: var(--brand-color);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
}

.pagination button:hover:not(:disabled) {
  background-color: var(--accent-color);
}

.pagination button:disabled {
  background-color: #cccccc;
  cursor: not-allowed;
}

.page-info {
  color: var(--text-secondary);
  font-size: 1rem;
}

.page-info strong {
  color: var(--accent-color);
}

.help-container {
  text-align: center;
  margin-top: 1.5rem;
}

.help-link {
  color: var(--text-secondary);
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.2s ease-in-out;
}

.help-link:hover {
  color: var(--accent-color);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: flex-start;
  overflow-y: auto;
  padding: 4rem 0;
  z-index: 1000;
}

.modal-content {
  background-color: var(--primary-bg);
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  max-width: 800px;
  width: 90%;
  position: relative;
}

.modal-close-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-secondary);
}

.modal-content h2 {
  color: var(--brand-color);
  margin-top: 0;
  margin-bottom: 1rem;
}

.modal-content p {
  color: var(--text-color);
  line-height: 1.6;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .app-header h1 {
    font-size: 2rem;
  }

  .controls {
    flex-direction: column;
    align-items: stretch;
  }

  .controls input, .controls select, .reset-btn {
    width: 100%;
    box-sizing: border-box; /* Ensure padding and border are included in the element's total width */
  }

  .table-container {
    overflow-x: auto; /* Enable horizontal scrolling for the table */
  }

  table {
    min-width: 700px; /* Ensure table doesn't shrink too much */
  }

  th, td {
    padding: 0.8rem 1rem;
    font-size: 0.9rem;
  }

  .pagination {
    flex-direction: column;
    gap: 0.8rem;
  }

  .pagination button {
    width: 100%;
    box-sizing: border-box;
  }

  .modal-content {
    width: 95%;
    padding: 1.5rem;
  }

  .modal-content h2 {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/DataViewer.css"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,uBAAuB,EAAE,2CAA2C;EACpE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;EACzB,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,wBAAwB;EACxB,gHAAgH;EAChH,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,eAAe;EACf,mBAAmB;EACnB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,qCAAqC;EACrC,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,4CAA4C;EAC5C,aAAa;AACf;;AAEA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,qCAAqC;IACrC,qBAAqB;IACrB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,YAAY;AAChB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,sBAAsB,EAAE,wEAAwE;EAClG;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;EAEA;IACE,gBAAgB,EAAE,yCAAyC;EAC7D;;EAEA;IACE,oBAAoB;IACpB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":["\n:root {\n  --primary-bg: #ffffff;\n  --secondary-bg: #f7f7f7; /* Un gris muy claro para sutil contraste */\n  --brand-color: #23223F;\n  --accent-color: #FD5F56;\n  --text-color: #333333;\n  --text-secondary: #555555;\n  --border-color: #eaeaea;\n  --shadow-color: rgba(0, 0, 0, 0.05);\n}\n\nbody {\n  background-color: var(--secondary-bg);\n  color: var(--text-color);\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.data-viewer {\n  max-width: 1400px;\n  margin: 2rem auto;\n  padding: 1rem;\n}\n\n.app-header {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.app-header h1 {\n  font-family: 'Montserrat', sans-serif;\n  color: var(--brand-color);\n  font-size: 2.8rem;\n  font-weight: 700;\n}\n\n.controls-container {\n  background-color: var(--primary-bg);\n  padding: 1.5rem;\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  margin-bottom: 2rem;\n}\n\n.controls {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  justify-content: flex-end;\n}\n\n.controls input, .controls select {\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  border: 1px solid var(--border-color);\n  border-radius: 8px;\n  background-color: var(--secondary-bg);\n  transition: all 0.2s ease-in-out;\n}\n\n.controls input:focus, .controls select:focus {\n  border-color: var(--accent-color);\n  box-shadow: 0 0 0 3px rgba(253, 95, 86, 0.2);\n  outline: none;\n}\n\n.reset-btn {\n    background-color: transparent;\n    color: var(--accent-color);\n    border: 1px solid var(--accent-color);\n    padding: 0.75rem 1rem;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 1rem;\n    font-weight: 500;\n    transition: all 0.2s ease-in-out;\n}\n\n.reset-btn:hover {\n    background-color: var(--accent-color);\n    color: white;\n}\n\n.table-container {\n  background-color: var(--primary-bg);\n  border-radius: 12px;\n  border: 1px solid var(--border-color);\n  overflow: hidden;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nthead {\n  background-color: var(--secondary-bg);\n}\n\nth {\n  padding: 1.25rem 1.5rem;\n  text-align: left;\n  font-weight: 600;\n  color: var(--brand-color);\n  border-bottom: 2px solid var(--accent-color);\n}\n\ntbody tr {\n  transition: background-color 0.15s ease-in-out;\n}\n\ntbody tr:not(:last-child) {\n  border-bottom: 1px solid var(--border-color);\n}\n\ntbody tr:hover {\n  background-color: var(--secondary-bg);\n}\n\ntd {\n  padding: 1rem 1.5rem;\n  color: var(--text-secondary);\n  vertical-align: middle;\n}\n\ntd:first-child {\n    color: var(--text-color);\n    font-weight: 500;\n}\n\n.status, .type {\n  padding: 0.3rem 0.75rem;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  display: inline-block;\n}\n\n.status.open {\n  background-color: #e6f7ff;\n  color: #1890ff;\n}\n\n.status.closed {\n  background-color: #fff1f0;\n  color: #f5222d;\n}\n\n.type.farmacia {\n  background-color: #e6fffb;\n  color: #13c2c2;\n}\n\n.type.establecimiento {\n  background-color: #fffbe6;\n  color: #faad14;\n}\n\n.pagination {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 2rem;\n  gap: 1rem;\n}\n\n.pagination button {\n  background-color: var(--brand-color);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 1rem;\n  font-weight: 500;\n  transition: all 0.2s ease-in-out;\n}\n\n.pagination button:hover:not(:disabled) {\n  background-color: var(--accent-color);\n}\n\n.pagination button:disabled {\n  background-color: #cccccc;\n  cursor: not-allowed;\n}\n\n.page-info {\n  color: var(--text-secondary);\n  font-size: 1rem;\n}\n\n.page-info strong {\n  color: var(--accent-color);\n}\n\n.help-container {\n  text-align: center;\n  margin-top: 1.5rem;\n}\n\n.help-link {\n  color: var(--text-secondary);\n  text-decoration: underline;\n  cursor: pointer;\n  transition: color 0.2s ease-in-out;\n}\n\n.help-link:hover {\n  color: var(--accent-color);\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  overflow-y: auto;\n  padding: 4rem 0;\n  z-index: 1000;\n}\n\n.modal-content {\n  background-color: var(--primary-bg);\n  padding: 2rem;\n  border-radius: 12px;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n  max-width: 800px;\n  width: 90%;\n  position: relative;\n}\n\n.modal-close-btn {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: var(--text-secondary);\n}\n\n.modal-content h2 {\n  color: var(--brand-color);\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\n.modal-content p {\n  color: var(--text-color);\n  line-height: 1.6;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .app-header h1 {\n    font-size: 2rem;\n  }\n\n  .controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .controls input, .controls select, .reset-btn {\n    width: 100%;\n    box-sizing: border-box; /* Ensure padding and border are included in the element's total width */\n  }\n\n  .table-container {\n    overflow-x: auto; /* Enable horizontal scrolling for the table */\n  }\n\n  table {\n    min-width: 700px; /* Ensure table doesn't shrink too much */\n  }\n\n  th, td {\n    padding: 0.8rem 1rem;\n    font-size: 0.9rem;\n  }\n\n  .pagination {\n    flex-direction: column;\n    gap: 0.8rem;\n  }\n\n  .pagination button {\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .modal-content {\n    width: 95%;\n    padding: 1.5rem;\n  }\n\n  .modal-content h2 {\n    font-size: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
